import { render, staticRenderFns } from "./ViewAsset.vue?vue&type=template&id=5d5dad7d"
import script from "./ViewAsset.vue?vue&type=script&lang=js"
export * from "./ViewAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports